module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon_family-f33b63835db2eda85b83489d20fe7ca9.svg";